/* eslint-disable camelcase */
import chart_donut_pie_Height from '@patternfly/react-tokens/dist/esm/chart_donut_pie_Height';
import chart_donut_pie_angle_Padding from '@patternfly/react-tokens/dist/esm/chart_donut_pie_angle_Padding';
import chart_donut_pie_Padding from '@patternfly/react-tokens/dist/esm/chart_donut_pie_Padding';
import chart_donut_pie_Width from '@patternfly/react-tokens/dist/esm/chart_donut_pie_Width';
// Donut theme
export const DonutTheme = {
    pie: {
        height: chart_donut_pie_Height.value,
        padding: chart_donut_pie_Padding.value,
        padAngle: chart_donut_pie_angle_Padding.value,
        width: chart_donut_pie_Width.value
    }
};
//# sourceMappingURL=donut-theme.js.map